import qs from 'qs'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ApiTagVer4 } from '../tags'
import { authLogout } from '../../../redux/actions/auth'
export const baseUrl =
  process.env.REACT_APP_API_v4_BASEURL ?? window.location.origin

const invalidateTokenEndpoint = '/api/Endusers/logout'
console.log(`gep.v4 (${process.env.NODE_ENV}):`, baseUrl)

/**
 * Hooks cannot be used here (only pure function). Any redux/state manipulation has to be done through:
 *  - (api as BaseQueryApi).getState() to read state from store
 *  - (api as BaseQueryApi).dispatch() to update state to the store
 */

// Request Interceptors
const accessQuery = fetchBaseQuery({
  baseUrl,
  paramsSerializer: (params) => {
    return qs.stringify(params)
  },
  prepareHeaders: (headers, api) => {
    const token = getSecurityTokenFromReduxStore(api.getState)
    if (token) {
      headers.set('authorization', token)
    }
    return headers
  },
})

// Base Query
const baseQuery = async (args, api, extraOptions) => {
  const result = await accessQuery(args, api, {
    ...extraOptions,
    refresh: true,
  })

  if (result?.error) {
    if (typeof result.error.status === 'number') {
      const response = result.error.data
      result.error.data = { ...response.error, originalData: null }
    } else {
      let message = ''
      let statusCode = 500
      let data
      if (result.error.status === 'FETCH_ERROR') {
        message = result.error.error
        statusCode = 500
        data = result.error.data
      }
      if (result.error.status === 'PARSING_ERROR') {
        message =
          result.error.status +
          ': ' +
          result.error.error +
          ' for ' +
          result.meta?.request.url
        statusCode = result.error.originalStatus
        data = result.error.data
      }
      if (result.error.status === 'TIMEOUT_ERROR') {
        message = result.error.status + ': ' + result.error.error
        statusCode = 408
        data = result.error.data
      }
      if (result.error.status === 'CUSTOM_ERROR') {
        message = result.error.status + ': ' + result.error.error
        statusCode = 400
        data = result.error.data
      }
      result.error.data = {
        message: message,
        name: result.error.status,
        statusCode: statusCode,
        originalData: data,
      }
    }
    console.error('api.v4.x:', result)
  }

  // un-authenticated access
  if (result?.error?.status === 401) {
    const token = getSecurityTokenFromReduxStore(api.getState)
    if (result?.error?.data?.code === 'INVALID_TOKEN') {
      console.log('[Unauthorized]: Expired token.')
    } else {
      console.log('[Authentication Error]:', result?.error?.data)
    }
    if (token) {
      await accessQuery(invalidateTokenEndpoint, api, extraOptions)
    }
    api.dispatch(authLogout())
    console.error('api.v4.x:', result)
    return result
  }
  // un-authorized access
  if (result?.error?.status === 403) {
    const token = getSecurityTokenFromReduxStore(api.getState)
    console.log('[Authorization Error]:', result?.error?.data)
    if (token) {
      await accessQuery(invalidateTokenEndpoint, api, extraOptions)
    }
    api.dispatch(authLogout())
  }
  return result
}

const getSecurityTokenFromReduxStore = (getState) => {
  // Attempt to get token from redux Store
  if (typeof getState === 'function') {
    const store = getState()

    const accessToken = store.auth?.info?.id ?? null
    if (accessToken) return accessToken
    else throw Error('Failed to get access token from the redux store')
  }
  throw Error('Failed to access redux store')
}

export const apiVer4 = createApi({
  reducerPath: 'api@v4',
  baseQuery: baseQuery,
  tagTypes: Object.values(ApiTagVer4),
  // eslint-disable-next-line no-unused-vars
  endpoints: (_builder) => ({}),
})
